import axios from "axios";

function getData(url){

  const getPromiseData = async (url) => {
    const data = await axios(url);
    return data;
 }
  const main = async () => {
    try{
      const result = await getPromiseData(url);
      return result;
    }
    catch(err){
      console.error(err);
    }
  }
  return main();
}

   export default getData;